import { render, staticRenderFns } from "./roomsSetting.vue?vue&type=template&id=5299cb72&"
import script from "./roomsSetting.vue?vue&type=script&lang=js&"
export * from "./roomsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports